// API configuration for different environments
const isDevelopment = process.env.NODE_ENV === 'development'
const isProduction = process.env.NODE_ENV === 'production'

// Base API URL configuration
// Base API URL configuration
export const API_BASE_URL = process.env.REACT_APP_SHORTFORM_API_URL || 'https://riftchess-backend.fly.dev'

// Helper function to build API URLs
export const apiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  return `${API_BASE_URL}/api/v1/${cleanEndpoint}`
}

// Export environment info for debugging
export const ENV_INFO = {
  isDevelopment,
  isProduction,
  nodeEnv: process.env.NODE_ENV,
  apiBaseUrl: API_BASE_URL
}